import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms'
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { debounceTime, filter, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-standing-order-list',
  templateUrl: './standing-order-list.component.html',
  styleUrls: ['./standing-order-list.component.css']
})
export class StandingOrderListComponent implements OnInit {
  trip: any;
  spacetypes: any
  members: any;
  // selectedStatus:any = ''
  standingorderMembers: any = [];
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  preMember: any;
  prespacetypes: any;
  search: any;
  user:any;
  todayDate: any
  filteredStandingorder: any;
  status: boolean = true
  numberOfRecords = NUMBER_OF_RECORDS
  userPermission = UserPermission;
  timeZone:any = timeZone;
  private searchSubject = new Subject<string>();
  constructor(
    private tripService: TripService,
    private spaceTypeService: SpaceTypeService,
    private router: Router,
    public permissionService: PermissionService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.getUser()
    this.getStandingorder(this.currentPage);
    this.getSpaceType()
    this.initializeSearch();
  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;

        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        if (Array.isArray(this.user?.member)) {
          this.preMember = this.user.member.reduce((obj: any, m: any) => {
            obj[m.id] = m;
            return obj;
          }, {});
        } else if (this.user?.member) {
          this.preMember = { [this.user.member.id]: this.user.member };
        } else {
          this.preMember = {};
        }

      }
    });
  }


  getStandingorder(page: number) {
    let queryParams:any = {
      limit: this.numberOfRecords,
      page,
      isActive: this.status,
      sortBy: 'pickup.time:asc',
    }
     if (this.search) {
      queryParams.search = this.search.trim();;
    }

    this.tripService.getAllStandingorder(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.standingorderMembers = data.results.map((item: any) => ({
          ...item,
          member: this.preMember ? this.preMember[item.member] : null
        }))
        this.filteredStandingorder = [...this.standingorderMembers]
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;

      }
    })
  }

  opendetailModal(trip: any) {
    this.trip = trip;
  }


  onPageChange(page: number) {
    this.currentPage = page;
    this.getStandingorder(page);
  }

  getSpaceType() {
    let queryParams = {
      isActive: true,
      limit: 9999,
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.prespacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  onSelectStatus() {
    this.getStandingorder(this.currentPage = 1);
  }

  newTrip() {
    this.router.navigate(['/trips/new'], {
      state: { isFromStandingOrder: true }
    });
  }

  onSearchInput() {
      this.searchSubject.next(this.search);
    }

    initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search:any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getStandingorder(this.currentPage);
      });
    }
}
